export default __webpack_public_path__ + "static/media/wall-clock.56442766.svg";